import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { NetworkPartners } from "./components/NetworkPartners";
import { About } from "./components/About";
import { CaseStudies } from "./components/CaseStudies";
import { FAQWithSearch } from "./components/FAQWithSearch";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Datenschutz } from "./components/Datenschutz";
import { Impressum } from "./components/Impressum";
import { AdminLogin } from "./components/admin/AdminLogin";
import { AdminDashboard } from "./components/admin/AdminDashboard";
import { AdminContacts } from "./components/admin/AdminContacts";
import { Toaster } from "./components/ui/sonner";

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <Services />
    <NetworkPartners />
    <About />
    <CaseStudies />
    <FAQWithSearch />
    <Contact />
    <Footer />
    <WhatsAppButton />
  </>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/contacts" 
            element={
              <ProtectedRoute>
                <AdminContacts />
              </ProtectedRoute>
            } 
          />

          {/* Catch-all — redirect any unknown URL (incl. removed /admin/bookings) to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
